var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"poster-box-vertical"},[_c('div',{staticClass:"thumb-box"},[(_vm.posterImage)?_c('div',{staticClass:"picture-area"},[_c('WebpImage',{attrs:{"imageInfo":{
          imageUrl: _vm.posterImage,
          width: 240,
          height: 360,
          onImageLoad: _vm.onImageLoad,
        }}})],1):_c('div',{staticClass:"no-thumb",attrs:{"aria-hidden":!_vm.isImageLoaded}},[_c('span',{staticClass:"alt-text"},[_vm._v(_vm._s(_vm.posterAltText))])])]),_c('div',{staticClass:"picture-area"},[_c('WebpImage',{attrs:{"imageInfo":{
        imageUrl: _vm.posterImage,
        width: 155,
        height: 87,
        option: 'b20',
        onImageLoad: _vm.onImageLoad,
      }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }